import { getColor } from 'utils/colors';
import { remCalc } from 'utils/remCalc';

export const styles = {};

export const overrides = {
    '.BlogPostList-root': {
        '.BlogPostList-results': {
            rowGap: remCalc(80),
            marginBottom: remCalc(80),
        },
        '.BlogPostList-card': {
            minWidth: 0,
        },
        '.BlogPostList-empty, .BlogPostList-loading': {
            fontFamily: 'var(--body-font)',
            fontSize: remCalc(18),
            lineHeight: remCalc(28),
            color: getColor('ivory', 700),
            paddingBottom: remCalc(20),
        },
        '.BlogPostList-pagination': {
            paddingBottom: remCalc(50),
        },
    },
};

export default styles;